import PortTobBar from "../common/top";
import Aboutme from "../inner/aboutme/about_me";
import Projects from "../inner/project/projects";
import Skills from "../inner/skills/skills";
import Experience from "../inner/experience/experience";
import AiTools from "../inner/ai/ai_tools";
import data from "../data/biodata.json";
import ContactUs from "../inner/contactus/contact_us";
import OnScroll from "../common/onscroll";
import Floater from "../common/floater";
import ThemeCustomizer from "../common/theme_customizer";
import { useTheme } from "../../theme/themeContext";

function Landing() {
  const { preferences } = useTheme();
  const templateId = preferences.templateId || "glass";
  const pagelist = data?.pages || [];
  const aboutme = data?.details?.about_me || [];
  const skillList = data?.details?.all_skills || [];
  const projectDetails = data?.details?.project_details || [];
  const histories = data?.details?.histories || [];
  const aiTools = data?.details?.ai_tools || [];
  const services = data?.details?.services || [];
  const contacts = data?.details?.contact_details || [];

  return (
    <div
      className={`main-landing-page template-shell template-shell--${templateId} mx-auto px-4 pb-24 text-skin-text md:px-6`}
    >
      <ThemeCustomizer />
      <PortTobBar list={pagelist} templateId={templateId} />
      <Floater />
      <div className="template-content space-y-8" id="main-content">
        <OnScroll>
          <Aboutme content={aboutme} services={services} />
        </OnScroll>
        <OnScroll>
          <Projects projectList={projectDetails} />
        </OnScroll>
        <OnScroll>
          <Skills allskills={skillList} />
        </OnScroll>
        <OnScroll>
          <AiTools list={aiTools} />
        </OnScroll>
        <Experience exp={histories} />
        <ContactUs contact={contacts} />
      </div>
    </div>
  );
}

export default Landing;
